import axios from '../api/axiosInstance';

export const fetchProductCategories = (params) => {
  return axios.get('/product-categories', { params });
};

export const createProductCategory = (data) => {
  return axios.post('/product-categories', data);
};

export const updateProductCategory = (id, data) => {
  return axios.put(`/product-categories/${id}`, data);
};

export const updateProductCategoryStatus = (id, status) => {
  return axios.patch(`/product-categories/${id}/status`, { status });
};

export const deleteProductCategory = (id) => {
  return axios.delete(`/product-categories/${id}`);
};

